import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

type ProntuarioProfileEmptyStateProps = {
	title: string;
	description?: string;
	icon: ReactNode;
	variant?: 'dark' | 'light';
	className?: string;
};

const ProntuarioProfileEmptyState = ({
	title,
	description,
	icon,
	variant = 'dark',
	className,
}: ProntuarioProfileEmptyStateProps) => (
	<div
		className={cn('flex items-center justify-center px-4 py-8', className)}
	>
		<div
			className={cn(
				'flex w-full max-w-[18rem] flex-col items-center gap-3 rounded-2xl border px-5 py-6 text-center shadow-[inset_0_1px_0_rgba(255,255,255,0.04)]',
				variant === 'light'
					? 'border-zinc-200 bg-zinc-50'
					: 'border-white/[0.08] bg-white/[0.03]',
			)}
		>
			<div
				className={cn(
					'flex size-11 items-center justify-center rounded-full',
					variant === 'light'
						? 'bg-zinc-100 text-zinc-500 ring-1 ring-zinc-200'
						: 'bg-[#8ab4f8]/10 text-[#8ab4f8]/80 ring-1 ring-[#8ab4f8]/20',
				)}
			>
				{icon}
			</div>
			<div className="space-y-1.5">
				<p
					className={cn(
						'text-[15px] font-medium leading-snug',
						variant === 'light'
							? 'text-zinc-800'
							: 'text-slate-200',
					)}
				>
					{title}
				</p>
				{description ? (
					<p
						className={cn(
							'text-[13px] leading-relaxed',
							variant === 'light'
								? 'text-zinc-600'
								: 'text-[#9aa0a6]',
						)}
					>
						{description}
					</p>
				) : null}
			</div>
		</div>
	</div>
);

export { ProntuarioProfileEmptyState };
